
// Storage utility functions for wishlist space management

const WISHLIST_SIZE_LIMIT = 25 * 1024 * 1024; // 25MB per wishlist
const IMAGE_SIZE_ESTIMATE = 500 * 1024; // Estimate 500KB per image on average

export function calculateWishlistSize(products = []) {
  // Estimate storage used by text content and images
  let totalSize = 0;
  
  products.forEach(product => {
    // Text content (title, url, etc.) - small overhead
    totalSize += (product.title?.length || 0) * 2; // UTF-16 encoding
    totalSize += (product.url?.length || 0) * 2;
    
    // Image size estimation
    if (product.image || product.imageUrl) {
      totalSize += IMAGE_SIZE_ESTIMATE;
    }
  });
  
  return totalSize;
}

export function isWishlistNearLimit(products = [], threshold = 0.8) {
  const currentSize = calculateWishlistSize(products);
  return currentSize >= (WISHLIST_SIZE_LIMIT * threshold);
}

export function isWishlistAtLimit(products = []) {
  const currentSize = calculateWishlistSize(products);
  return currentSize >= WISHLIST_SIZE_LIMIT;
}

export function formatStorageSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function getRemainingStorage(products = []) {
  const used = calculateWishlistSize(products);
  return Math.max(0, WISHLIST_SIZE_LIMIT - used);
}
